const useListColumns = () => {
  return [
    {
      Header: "Title",
      accessor: "title",
      disableGlobalFilter: true,
    },
    {
      Header: "Date",
      accessor: "date",
      sortType: (rowA: any, rowB: any) => rowA.original._dateTs - rowB.original._dateTs,
    },
    {
      Header: "Type",
      accessor: "type",
      disableGlobalFilter: true,
    },
    {
      Header: "Created At",
      accessor: "createDate",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._createDateTs - rowB.original._createDateTs,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
